import React, { useState, useEffect } from 'react';
import '../../../Components/style/admin.css'
import { FiBox, FiDelete, FiDownload, FiEdit, FiList, FiRefreshCcw } from 'react-icons/fi';
import { firebase } from '../../../base';
import { Radio, Table, Tag, notification, Spin } from 'antd';
import MetaTags from '../../../Components/meta';
import Modal from '../../../Components/modal';
import { getApplications, getClientsByCompany } from '../../../Components/firestore/company';
import { MdCheck, MdClose, MdMoneyOff } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

export default function Applications() {
    const navigate = useNavigate();
    const [modalAccept, setModalAccept] = useState(false);
    const [modalReject, setModalReject] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [loading, setLoading] = useState(false);

    const [selectedApplication, setSelectedAplication] = useState(null);
    const [applications, setApplications] = useState([]);
    const [menu, setMenu] = useState('pending');

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setLoadingData(true);
        const applicationsData = await getApplications();
        const sortedApplications = applicationsData.sort((a, b) => 
            new Date(b.createdAt) - new Date(a.createdAt)
        );
        setApplications(sortedApplications);
        setLoadingData(false);
    }

    const handleAccept = (record) => {
        setSelectedAplication(record);
        setModalAccept(true);
    }

    const handleReject = (record) => {
        setSelectedAplication(record);
        setModalReject(true);
    }

    const goDownload = (id) => {
        navigate(`/admin/document/${id}`);
    }

    const acceptApplication = async (id) => {
        setLoading(true);
        try {
            await firebase.firestore()
                .collection('submissoes')
                .doc(id)
                .update({ 
                    status: 'accepted',
                    metadata: firebase.firestore.FieldValue.arrayUnion({
                        status: 'accepted',
                        date: new Date().toISOString(),
                        user: firebase.auth()?.currentUser?.uid || 'unknown',
                        isNotified: false
                    }) 
                });
            notification.success({
                message: <p className='title-small'>Application Accepted</p>,
                description: <p className='text-small'>The application has been accepted successfully.</p>
            });
            setModalAccept(false);
            getData();
        }
        catch (error) {
            notification.error({
                message: <p className='title-small'>Error</p>,
                description: error.message
            });
        }
        finally {
            setLoading(false);
        }
    }

    const rejectApplication = async (id) => {
        setLoading(true);
        try {
            await firebase.firestore()
                .collection('submissoes')
                .doc(id)
                .update({ 
                    status: 'rejected',
                    metadata: firebase.firestore.FieldValue.arrayUnion({
                        status: 'rejected',
                        date: new Date().toISOString(),
                        user: firebase.auth()?.currentUser?.uid || 'unknown',
                        isNotified: false
                    })
                });
            notification.success({
                message: <p className='title-small'>Application Rejected</p>,
                description: <p className='text-small'>The application has been rejected successfully.</p>
            });
            setModalReject(false);
            getData();
        }
        catch (error) {
            notification.error({
                message: <p className='title-small'>Error</p>,
                description: error.message
            });
        }
        finally {
            setLoading(false);
        }
    }


    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            render: (text, record, index) => index + 1,
            width: '4%',
        },
        {
            title: 'Name',
            dataIndex: 'studentIdentity',
            key: 'studentIdentity',
            render: (studentIdentity) => {
                return (
                    <p className='text-small'>{studentIdentity?.name}</p>
                )
            },
            sorter: (a, b) => a.studentIdentity?.name.localeCompare(b.studentIdentity?.name),
        },
        {
            title: 'Gender',
            dataIndex: 'studentIdentity',
            key: 'studentIdentity',
            render: (studentIdentity) => {
                return (
                    <p className='text-small'>{studentIdentity?.gender}</p>
                )
            },
            width: '6%'
        },
        {
            title: 'Date of Birth',
            dataIndex: 'studentIdentity',
            key: 'studentIdentity',
            render: (studentIdentity) => {
                return (
                    <p className='text-small'>{studentIdentity?.dob}</p>
                )
            },
            width: '10%'
        },
        {
            title: 'Level',
            dataIndex: 'level',
            key: 'level',
            width: '6%'
        },
        {
            title: 'Date of Application',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (createdAt) => {
                const date = new Date(createdAt);
                const formattedDate = date.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
                return (
                    <p className='text-small'>{formattedDate}</p>
                )
            },
            width: '15%',
            sorter: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <input
                        type="date"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <button
                        type="button"
                        onClick={() => {
                            confirm();
                        }}
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Filter
                    </button>
                    <button
                        onClick={() => {
                            clearFilters();
                            confirm();
                        }}
                    >
                        Reset
                    </button>
                </div>
            ),
            onFilter: (value, record) => {
                const applicationDate = new Date(record.createdAt).toISOString().split('T')[0];
                return applicationDate === value;
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                return (
                    <>
                        <Tag color={'green'}>{status}</Tag>
                    </>
                )
            },
            width: '10%'
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <div className='flex items-center gap-4'>
                        <FiDownload className='cursor-pointer' color='#242323' onClick={() => goDownload(record.id)} />
                        {record.status === 'pending' && <>
                            <MdCheck className='cursor-pointer' color='#242323' onClick={() => handleAccept(record)} />
                            <FiDelete className='cursor-pointer' color='#242323' onClick={() => handleReject(record)} />
                        </>}
                    </div>
                )
            },
            width: '7%',
        },
    ];

    return (
        <>
            <MetaTags
                title='Applications | Institute Nilia'
                description='Applications for Institute Nilia'
                image={require('../../../assets/icons/nilia.webp')}
                name='Institute Nilia'
            />
            <div className="admin-page">
                <div className='w-full flex flex-col bg-white rounded-lg p-6'>
                    <div className='flex items-center justify-between'>
                        <p className='title-medium mb-3'>Applications</p>
                        <button className='btn-signup' onClick={getData}>
                            <FiRefreshCcw size={15} />
                        </button>
                    </div>
                    <div className='w-full bg-gray-100 p-2 gap-2 rounded-lg flex items-center justify-start mt-2'>
                        <div onClick={() => setMenu('pending')} className={`menu-opt ${menu === 'pending' ? 'active' : ''}`}>
                            <FiList size={18} className='menu-icon' />
                            <p className='text-ss'>Pending</p>
                        </div>
                        <div onClick={() => setMenu('accepted')} className={`menu-opt ${menu === 'accepted' ? 'active' : ''}`}>
                            <MdCheck size={18} className='menu-icon' />
                            <p className='text-ss'>Accepted</p>
                        </div>
                        <div onClick={() => setMenu('rejected')} className={`menu-opt ${menu === 'rejected' ? 'active' : ''}`}>
                            <MdClose size={18} className='menu-icon' />
                            <p className='text-ss'>Rejected</p>
                        </div>
                    </div>
                    <div className='w-full flex mt-4'>
                        <Table
                            className='w-full'
                            loading={loadingData}
                            columns={columns}
                            dataSource={applications.filter(app => app.status === menu)}
                            size='small'
                            pagination={{ pageSizeOptions: ['10', '20', '50', '100'], showSizeChanger: true }}
                            rowKey={record => record.id}
                            locale={{
                                emptyText: () => (
                                    <>
                                        <div className='w-full flex flex-col items-center justify-bcenter gap-4 py-5 px-4'>
                                            <FiBox size={25} className='text-gray-400' />
                                            <p className='text-ss text-gray-400'>No Applications Found</p>
                                        </div>
                                    </>
                                )
                            }}
                        />
                    </div>
                </div>
            </div>
            <Modal title='Accept Application' visible={modalAccept} onClose={() => setModalAccept(false)}>
                <div className='w-full flex flex-col items-start justify-center gap-4 py-5 px-4'>
                    <p className='text-ss text-black'>Are you sure you want to accept this Application?</p>
                    <div className='flex items-center justify-end gap-4 w-full'>
                        <button onClick={() => setModalReject(false)} className='btn-cancel w-full'>
                            Cancel
                        </button>
                        <button className='btn-signup w-full' onClick={() => acceptApplication(selectedApplication?.id)}>
                            {loading ?
                                <Spin size='small' /> : 'Accept'}
                        </button>
                    </div>
                </div>
            </Modal>
            <Modal title='Reject Application' visible={modalReject} onClose={() => setModalReject(false)}>
                <div className='w-full flex flex-col items-start justify-center gap-4 py-5 px-4'>
                    <p className='text-ss text-black'>Are you sure you want to reject this Application?</p>
                    <div className='flex items-center justify-end gap-4 w-full'>
                        <button onClick={() => setModalReject(false)} className='btn-cancel w-full'>
                            Cancel
                        </button>
                        <button className='btn-signup w-full' onClick={() => rejectApplication(selectedApplication?.id)}>
                            {loading ?
                                <Spin size='small' /> : 'Reject'}
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    )

}